// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkinOutlinedSvg from "@fishx/icons-svg/es/asn/SkinOutlined";
import FishxIcon from '../components/FishxIcon';

var SkinOutlined = function SkinOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkinOutlinedSvg
  }));
};

SkinOutlined.displayName = 'SkinOutlined';
export default React.forwardRef(SkinOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SkinOutlined.js
// module id = 4127
// module chunks = 0